<template>
  <div class="regist-page">
    <div class="form">
      <div class="title-img"><img src="@/assets/feedback.png" width="388" alt=""></div>
      <el-form
        :rules="companyRules"
        ref="form"
        label-position="right"
        label-width="30%"
        :model="form"
      >
        <el-form-item label="订单号">
          <el-input v-model="form.orderId" onkeyup="value=value.replace(/[^\d]/g,'')"
            placeholder="请输入订单号"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="linkman">
          <el-input v-model="form.linkman" placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="telphone">
          <el-input :maxlength="11" v-model="form.telphone" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="邮箱地址" prop="email">
          <el-input v-model="form.email" placeholder="请输入邮箱地址"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input type="textarea" v-model="form.content" placeholder="请输入反馈说明"></el-input>
        </el-form-item>

        <!-- <el-form-item label style="height: 20px;">
          <div style="line-height: 1">
            <el-checkbox style="margin-right: 4px" v-model="isRead" />我已阅读并接受
            <button type="button" class="common-btn-text">《库蜂网用户协议》</button>
          </div>
        </el-form-item>-->
        <!-- :disabled="!isRead" -->
        <el-form-item>
          <button
            type="button"
            style="width: 420px;height: 39px;font-size:18px;"
            class="common-btn-primary"
            @click="submitForm('form')"
          >提交</button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { adviceAdd } from "@/js/api";
import { validatePhone, validateEmail } from "@/utils/util";

export default {
  name: "UserHome",
  data() {
    return {
      isRead: false,
      form: {
        orderId: "",
        linkman: "",
        telphone: "",
        email: "",
        content: ""
      },
      companyRules: {
        content: [
          { required: true, message: "请输入反馈内容", trigger: "blur" }
        ],
        telphone: [
          { required: true, message: "请输入11位手机号", trigger: "change" },
          { min: 11, max: 11, message: "请输入11位手机号", trigger: "blur" },
          { validator: validatePhone, trigger: "blur"}
        ],
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "change" },
          { validator: validateEmail, trigger: "blur" }
        ],
        linkman: [
          { required: true, message: "请输入联系人", trigger: "change" }
        ]
      },
      telFlag: true
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          adviceAdd(this.form).then(res => {
            if (res.code == 200) {
              this.$message.success(res.message);
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    goOrder() {
      this.$router.push("/user/order");
    }
  },
  mounted() {}
};
</script>
<style scoped>

</style>
